
import styled from 'styled-components'
import { FaTrash } from 'react-icons/fa'

export const TrashIcon = styled(FaTrash)`
    flex-shrink: 0;
    & * { pointer-events: none; }
`